module.exports = __webpack_public_path__ + "static/img/yangguangxingui_icon.134bddd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/yangguangxingui_icon.png
// module id = V+X7
// module chunks = 1